(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bmc-form"] && !Shopify.designMode) return;
  try {
    
  
  document.addEventListener("DOMContentLoaded", function() {

      document.querySelectorAll(".bmc-form").forEach(function(form) {

          // Material Design: Handle filled state for selects
          function updateFloatingLabels() {
            const fields = form.querySelectorAll('.bmc-field');
            fields.forEach(field => {
              const input = field.querySelector('input:not([type="checkbox"]):not([type="radio"]), select, textarea');
              const label = field.querySelector('label');

              if (input && label) {
                // Date/time inputs and selects always keep label floating - CSS handles these
                const dateTimeTypes = ['date', 'datetime-local', 'time', 'month', 'week','file'];
                if ((input.tagName === 'INPUT' && dateTimeTypes.includes(input.type)) || input.tagName === 'SELECT') {
                  return; // Skip, CSS handles these
                }

                // Check if input has focus or has value
                const hasFocus = document.activeElement === input;
                const hasValue = input.value && input.value.trim() !== '';

                if (hasFocus || hasValue) {
                  label.style.top = '-8px';
                  label.style.left = '8px';
                  label.style.fontSize = '12px';
                  label.style.color = hasFocus ? 'black' : '#666';
                } else {
                  // Reset label when no value and no focus
                  label.style.top = '20px';
                  label.style.left = '12px';
                  label.style.fontSize = '16px';
                  label.style.color = '#666';
                }
              }
            });
          }

          // Monitor field value changes for floating label updates
          let fieldValueCache = new Map();

          function monitorFieldChanges() {
            const fields = form.querySelectorAll('.bmc-field input:not([type="checkbox"]):not([type="radio"]), .bmc-field select, .bmc-field textarea');

            let hasChanges = false;
            fields.forEach(field => {
              const currentValue = field.value;
              const cachedValue = fieldValueCache.get(field);

              if (currentValue !== cachedValue) {
                fieldValueCache.set(field, currentValue);
                hasChanges = true;
              }
            });

            if (hasChanges) {
              updateFloatingLabels();
            }

            requestAnimationFrame(monitorFieldChanges);
          }

          // --- CascadingDropdown class ---
          class CascadingDropdown {
            constructor(container, form) {
              this.container = container;
              this.form = form;
              this.heading = container.dataset.heading;
              this.trigger = container.querySelector('.bmc-cascade-trigger');
              this.triggerText = container.querySelector('.bmc-cascade-trigger-text');
              this.panel = container.querySelector('.bmc-cascade-panel');
              this.breadcrumb = container.querySelector('.bmc-cascade-breadcrumb');
              this.searchInput = container.querySelector('.bmc-cascade-search');
              this.viewport = container.querySelector('.bmc-cascade-viewport');
              this.clearBtn = container.querySelector('.bmc-cascade-clear-btn');
              this.validityInput = container.querySelector('.bmc-cascade-validity');
              this.summary = container.querySelector('.bmc-cascade-summary');
              this.summaryContent = container.querySelector('.bmc-cascade-summary-content');
              this.field = container.querySelector('.bmc-field');
              this.resetBtn = container.querySelector('.bmc-cascade-reset-btn');
              if (this.resetBtn) {
                this.resetBtn.addEventListener('click', () => {
                  this._clearSelection();
                  this._close();
                });
              }
              this.placeholder = container.dataset.placeholder || '- Select one -';
              this.readonly = this.trigger && this.trigger.disabled;

              this.mode = container.dataset.cascadeMode || 'multiple';
              this.singleType = container.dataset.singleType || '';
              this.columns = [];
              this.columnsLabels = (container.dataset.columnsLabels || '').split(',').map(s => s.trim()).filter(Boolean);

              this.levelsConfig = (container.dataset.levels || '').split(',').map(s => s.trim()).filter(Boolean);
              this.fieldNames = (container.dataset.fieldNames || '').split(',').map(s => s.trim()).filter(Boolean);
              this.breadcrumbLabels = (container.dataset.breadcrumbLabels || '').split(',').map(s => s.trim()).filter(Boolean);

              this.rows = [];
              this.levels = [];
              this.hiddenInputs = {};
              this.selections = [];
              this.currentLevel = 0;
              this.isOpen = false;
              this.dataLoaded = false;

              if (!this._validateConfig()) return;

              this._createHiddenInputs();
              this._bindEvents();
              this._loadData();
            }

            _validateConfig() {
              let msg = '';

              if (this.mode === 'single') {
                if (!this.singleType) {
                  msg = '\u26A0 Cascading Dropdown misconfigured: single mode requires a metaobject type.';
                } else if (this.columnsLabels.length === 0) {
                  msg = '\u26A0 Cascading Dropdown misconfigured: single mode requires at least one column label.';
                }
              } else {
                const lc = this.levelsConfig.length;
                const fn = this.fieldNames.length;
                const bl = this.breadcrumbLabels.length;
                if (lc === 0 || lc !== fn || lc !== bl) {
                  msg = '\u26A0 Cascading Dropdown misconfigured: ' +
                    lc + ' level' + (lc !== 1 ? 's' : '') + ', ' +
                    fn + ' field name' + (fn !== 1 ? 's' : '') + ', ' +
                    bl + ' breadcrumb label' + (bl !== 1 ? 's' : '') + '. ' +
                    'All three must have the same number of items.';
                }
              }

              if (msg) {
                const errDiv = document.createElement('div');
                errDiv.style.cssText = 'border:2px solid #c00;background:#fee;color:#900;padding:12px 16px;border-radius:6px;font-size:14px;line-height:1.4;';
                errDiv.textContent = msg;
                this.container.prepend(errDiv);

                if (this.trigger) this.trigger.style.display = 'none';
                if (this.panel) this.panel.style.display = 'none';

                return false;
              }
              return true;
            }

            _createHiddenInputs() {
              const names = this.mode === 'single' ? this.columns : this.fieldNames;
              names.forEach(name => {
                if (this.hiddenInputs[name]) return;
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = name;
                input.value = '';
                this.container.appendChild(input);
                this.hiddenInputs[name] = input;
              });
            }

            async _loadData() {
              try {
                const locale = form.querySelector('input[name="language"]') ? form.querySelector('input[name="language"]').value : 'en';
                const isDesigner = !!(window.Shopify && Shopify.designMode);

                if (this.mode === 'single') {
                  const resp = await fetch('/apps/bmc/metaobjects/' + this.singleType + '/getall', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      isDesigner: isDesigner,
                      filters: '',
                      type: this.singleType,
                      metafieldKey: '',
                      locale: locale,
                      CompanyIDColumnName:"",
                      filterByCompany:false,
                      testCompanyId:""
                    })
                  });
                  const raw = await resp.json();
                  const items = Array.isArray(raw) ? raw : (raw && Array.isArray(raw.data) ? raw.data : []);

                  // Derive column keys from the first item
                  if (items.length > 0) {
                    const skip = new Set(['id', 'handle', 'system','updatedAt']);
                    const isCanonical = (k) => typeof k === 'string' && k.endsWith('_canonical');
                    if (items[0].fields && Array.isArray(items[0].fields)) {
                      this.columns = items[0].fields.map(f => f.key).filter(k => !isCanonical(k));
                    } else {
                      this.columns = Object.keys(items[0]).filter(k => !skip.has(k) && !isCanonical(k));
                    }
                  }

                  // Create hidden inputs now that we know the columns
                  this._createHiddenInputs();

                  this.rows = items.map(item => {
                    const row = {};
                    this.columns.forEach(col => {
                      row[col] = this._extractFieldCanonical(item, col);
                      row[col + '__display'] = this._extractField(item, col);
                    });
                    return row;
                  });

                  this.levels = this.columns.map((col, i) => ({
                    type: col,
                    breadcrumbLabel: this.columnsLabels[i] || col,
                    input: this.hiddenInputs[col]
                  }));
                } else {
                  const types = this.levelsConfig;
                  const labels = this.breadcrumbLabels;
                  const fieldNames = this.fieldNames;

                  const fetches = types.map(type =>
                    fetch('/apps/bmc/metaobjects/' + type + '/getall', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        isDesigner: isDesigner,
                        filters: '',
                        type: type,
                        metafieldKey: '',
                        locale: locale
                      })
                    }).then(r => r.json()).then(raw => Array.isArray(raw) ? raw : (raw && Array.isArray(raw.data) ? raw.data : []))
                  );
                  const results = await Promise.all(fetches);

                  this.levels = results.map((items, i) => ({
                    type: types[i],
                    breadcrumbLabel: labels[i] || types[i],
                    items: items.map(item => ({
                      id: (item.system && item.system.id) ? item.system.id : (item.id || ''),
                      label: this._extractField(item, 'label'),
                      value: this._extractField(item, 'value'),
                      parent: this._extractField(item, 'parent')
                    })),
                    input: this.hiddenInputs[fieldNames[i]]
                  }));
                }

                this.dataLoaded = true;
                this._applyDefaultValue();
              } catch (err) {
                console.error('CascadingDropdown: fetch error', err);
              }
            }

            _applyDefaultValue() {
              const defaultVal = this.container.dataset.defaultValue;
              if (!defaultVal) return;

              const defaults = defaultVal.split(',').map(s => s.trim());

              if (this.mode === 'single') {
                // Single mode: match values against row data
                for (let i = 0; i < Math.min(defaults.length, this.levels.length); i++) {
                  const val = defaults[i];
                  if (!val) continue;
                  const col = this.columns[i];
                  const matchRow = this.rows.find(r => r[col] === val);
                  const display = matchRow ? (matchRow[col + '__display'] || val) : val;
                  this.selections[i] = { id: val, display, value: val };
                  if (this.levels[i] && this.levels[i].input) {
                    this.levels[i].input.value = val;
                  }
                }
              } else {
                // Multiple mode: find items by value in each level
                for (let i = 0; i < Math.min(defaults.length, this.levels.length); i++) {
                  const val = defaults[i];
                  if (!val) continue;
                  const level = this.levels[i];
                  const match = level.items.find(item => item.value === val || item.label === val);
                  if (match) {
                    this.selections[i] = { id: match.id, display: match.label, value: match.value };
                    level.input.value = match.value;
                  } else {
                    // No match found, set value directly
                    this.selections[i] = { id: val, display: val, value: val };
                    level.input.value = val;
                  }
                }
              }

              // If all levels have selections, finalize
              if (this.selections.filter(s => s).length === this.levels.length) {
                this._finalize();
              }
            }

            _extractField(item, key) {
              if (item.fields && Array.isArray(item.fields)) {
                const f = item.fields.find(f => f.key === key);
                return f ? f.value : '';
              }
              return item[key] || '';
            }

            _extractFieldCanonical(item, key) {
              const canonKey = key + '_canonical';
              if (item.fields && Array.isArray(item.fields)) {
                const canonField = item.fields.find(f => f.key === canonKey);
                if (canonField && canonField.value != null && canonField.value !== '') {
                  return canonField.value;
                }
                const f = item.fields.find(f => f.key === key);
                return f ? f.value : '';
              }
              if (item[canonKey] != null && item[canonKey] !== '') return item[canonKey];
              return item[key] || '';
            }

            _bindEvents() {
              this.trigger.addEventListener('click', () => this._toggle());
              this.clearBtn.addEventListener('click', (e) => { e.stopPropagation(); this._clearSelection(); });
              this.searchInput.addEventListener('input', () => this._filterCurrentLevel());

              // Close on outside click
              document.addEventListener('click', (e) => {
                if (this.isOpen && !this.container.contains(e.target)) {
                  this._close();
                }
              });

              // Close on Escape
              document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && this.isOpen) {
                  this._close();
                }
              });
            }

            _toggle() {
              if (this.isOpen) {
                this._close();
              } else {
                this._open();
              }
            }

            _open() {
              if (!this.dataLoaded || this.readonly) return;
              this.isOpen = true;
              this.panel.style.display = 'flex';
              if (this.summary) this.summary.style.display = 'none';
              if (this.field) this.field.style.display = '';
              this.searchInput.value = '';
              if (this.levels.length > 0) {
                this._renderLevel(this.selections.length > 0 ? this.selections.length : 0);
              }
            }

            _close() {
              this.isOpen = false;
              this.panel.style.display = 'none';
              // Show summary again if there are selections
              if (this.summary && this.selections.filter(s => s).length === this.levels.length) {
                this.summary.style.display = 'block';
              }
            }

            _renderLevel(index) {
              if (index >= this.levels.length) return;
              this.currentLevel = index;
              const level = this.levels[index];

              this.searchInput.placeholder = 'Search...';
              this.searchInput.value = '';

              let items;

              if (this.mode === 'single') {
                let filteredRows = this.rows;
                for (let i = 0; i < index; i++) {
                  if (this.selections[i]) {
                    const col = this.columns[i];
                    filteredRows = filteredRows.filter(row => row[col] === this.selections[i].value);
                  }
                }
                const col = this.columns[index];
                const seen = new Map();
                filteredRows.forEach(row => {
                  const canon = row[col];
                  if (canon && !seen.has(canon)) {
                    seen.set(canon, row[col + '__display'] || canon);
                  }
                });
                items = [...seen].map(([value, label]) => ({ id: value, label, value }));
              } else {
                items = level.items;

                // Filter by parent if not root level
                if (index > 0) {
                  const parentSelection = this.selections[index - 1];
                  if (parentSelection) {
                    const parentId = parentSelection.id;
                    items = items.filter(item => {
                      const ref = item.parent;
                      return ref === parentId ||
                             ref === 'gid://shopify/Metaobject/' + parentId ||
                             (parentId && parentId.toString().includes(ref)) ||
                             (ref && ref.toString().includes(parentId));
                    });
                  }
                }
              }

              this._renderItems(items, index);
              this._renderBreadcrumb();
              this._animateToLevel(index, index > (this._prevLevel || 0) ? 'forward' : 'back');
              this._prevLevel = index;
            }

            _renderItems(items, levelIndex) {
              const isLastLevel = levelIndex === this.levels.length - 1;

              this.viewport.innerHTML = '';
              this.viewport.dataset.levelIndex = levelIndex;

              items.forEach(item => {
                const row = document.createElement('div');
                row.className = 'bmc-cascade-item';
                row.dataset.searchText = (item.label || '').toLowerCase();
                row.dataset.value = item.value;

                // Check if this item is currently selected
                if (this.selections[levelIndex] && this.selections[levelIndex].value === item.value) {
                  row.classList.add('selected');
                }

                const label = document.createElement('span');
                label.className = 'bmc-cascade-item-label';
                label.textContent = item.label;
                row.appendChild(label);

                if (!isLastLevel) {
                  const chevron = document.createElement('span');
                  chevron.className = 'bmc-cascade-item-chevron';
                  chevron.innerHTML = '&#8250;';
                  row.appendChild(chevron);
                }

                row.addEventListener('click', (e) => {
                  e.stopPropagation();
                  this._selectItem(item, levelIndex);
                });
                this.viewport.appendChild(row);
              });

              if (items.length === 0) {
                const empty = document.createElement('div');
                empty.className = 'bmc-cascade-empty';
                empty.textContent = 'No items found';
                this.viewport.appendChild(empty);
              }
            }

            _selectItem(item, levelIndex) {
              const level = this.levels[levelIndex];

              // Store selection
              this.selections[levelIndex] = { id: item.id, display: item.label, value: item.value };

              // Clear forward selections
              for (let i = levelIndex + 1; i < this.levels.length; i++) {
                this.selections[i] = null;
                this.levels[i].input.value = '';
                this.levels[i].input.dispatchEvent(new Event('change', { bubbles: true }));
              }

              // Update this level's hidden input
              level.input.value = item.value;
              level.input.dispatchEvent(new Event('change', { bubbles: true }));

              const isLastLevel = levelIndex === this.levels.length - 1;
              if (isLastLevel) {
                this._finalize();
              } else {
                this._renderLevel(levelIndex + 1);
              }
            }

            _finalize() {
              const validSelections = this.selections.filter(s => s);

              // Trigger shows only the last level
              const lastSelection = validSelections[validSelections.length - 1];
              this.triggerText.textContent = lastSelection ? lastSelection.display : this.placeholder;

              // Update validity input
              if (this.validityInput) {
                this.validityInput.value = lastSelection ? lastSelection.display : '';
              }

              // Render summary box
              if (this.summary && this.summaryContent) {
                this.summaryContent.innerHTML = '';
                validSelections.forEach((sel, i) => {
                  const line = document.createElement('div');
                  line.className = 'address-line';

                  const label = document.createElement('span');
                  label.className = 'address-label';
                  label.textContent = this.levels[i].breadcrumbLabel+":";

                  const value = document.createElement('span');
                  value.className = 'address-value';
                  value.textContent = sel.display;

                  line.appendChild(label);
                  line.appendChild(value);
                  this.summaryContent.appendChild(line);
                });
                this.summary.style.display = 'block';
                if (this.field) this.field.style.display = 'none';
              }

              this._close();

              // Dispatch change events on all level inputs
              this.levels.forEach(level => {
                level.input.dispatchEvent(new Event('change', { bubbles: true }));
              });
            }

            _renderBreadcrumb() {
              this.breadcrumb.innerHTML = '';

              for (let i = 0; i <= this.currentLevel; i++) {
                const level = this.levels[i];

                if (i > 0) {
                  const sep = document.createElement('span');
                  sep.className = 'bmc-cascade-breadcrumb-sep';
                  sep.textContent = ' > ';
                  this.breadcrumb.appendChild(sep);
                }

                const link = document.createElement('span');

                if (i < this.currentLevel) {
                  // Past level - clickable
                  link.className = 'bmc-cascade-breadcrumb-link';
                  const sel = this.selections[i];
                  link.textContent = sel ? sel.display : level.breadcrumbLabel;
                  const idx = i;
                  link.addEventListener('click', (e) => {
                    e.stopPropagation();
                    // Go back to this level, clear forward selections
                    for (let j = idx + 1; j < this.levels.length; j++) {
                      this.selections[j] = null;
                      this.levels[j].input.value = '';
                      this.levels[j].input.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                    this._renderLevel(idx);
                  });
                } else {
                  // Current level label
                  link.className = 'bmc-cascade-breadcrumb-current';
                  link.textContent = level.breadcrumbLabel;
                }

                this.breadcrumb.appendChild(link);
              }
            }

            _animateToLevel(index, direction) {
              const animClass = direction === 'forward' ? 'bmc-cascade-slide-in-right' : 'bmc-cascade-slide-in-left';
              this.viewport.classList.remove('bmc-cascade-slide-in-right', 'bmc-cascade-slide-in-left');
              // Force reflow
              void this.viewport.offsetWidth;
              this.viewport.classList.add(animClass);
              setTimeout(() => {
                this.viewport.classList.remove(animClass);
              }, 200);
            }

            _filterCurrentLevel() {
              const query = this.searchInput.value.toLowerCase();
              const items = this.viewport.querySelectorAll('.bmc-cascade-item');
              items.forEach(item => {
                const text = item.dataset.searchText || '';
                item.style.display = text.includes(query) ? '' : 'none';
              });
            }

            _clearSelection() {
              this.selections = [];
              this.levels.forEach(level => {
                level.input.value = '';
                level.input.dispatchEvent(new Event('change', { bubbles: true }));
              });

              this.triggerText.textContent = this.placeholder;

              if (this.validityInput) {
                this.validityInput.value = '';
              }

              // Hide summary box and show field again
              if (this.summary) {
                this.summary.style.display = 'none';
              }
              if (this.field) this.field.style.display = '';

              this._renderLevel(0);
            }
          }
          // --- End CascadingDropdown class ---

          // --- VariantPicker class ---
          class VariantPicker {
            constructor(container) {
              this.container = container;
              this.heading = container.dataset.heading;
              this.field = container.querySelector('.bmc-variant-field');
              this.searchInput = container.querySelector('.bmc-variant-search');
              this.suggestions = container.querySelector('.bmc-variant-suggestions');
              this.itemsContainer = container.querySelector('.bmc-variant-items');
              this.hiddenInput = container.querySelector('input[type="hidden"]');
              this.loadingEl = container.querySelector('.bmc-variant-loading');
              this.searchSpinner = container.querySelector('.bmc-variant-search-spinner');
              this.selected = [];
              this.debounceTimer = null;

              this._bindEvents();
              this._loadDefaults();
            }

            _bindEvents() {
              this.searchInput.addEventListener('input', () => {
                clearTimeout(this.debounceTimer);
                const query = this.searchInput.value.trim();
                if (query.length < 2) {
                  this.suggestions.innerHTML = '';
                  return;
                }
                this.debounceTimer = setTimeout(() => this._search(query), 300);
              });

              document.addEventListener('click', (e) => {
                if (!this.container.contains(e.target)) {
                  this.suggestions.innerHTML = '';
                }
              });
            }

            async _search(sku) {
              try {
                this.searchSpinner.style.display = 'block';
                const resp = await fetch('/apps/bmc/products/variant-by-sku/' + encodeURIComponent(sku));
                this.searchSpinner.style.display = 'none';
                if (!resp.ok) {
                  this.suggestions.innerHTML = '';
                  return;
                }
                const data = await resp.json();
                this._showSuggestion(data);
              } catch (e) {
                this.searchSpinner.style.display = 'none';
                this.suggestions.innerHTML = '';
              }
            }

            _showSuggestion(data) {
              this.suggestions.innerHTML = '';
              if (!data || !data.id) return;
              if (this.selected.some(s => s.id === data.id)) return;

              const div = document.createElement('div');
              div.className = 'bmc-variant-suggestion-item';
              div.innerHTML = '<div class="bmc-variant-suggestion-info"><span class="variant-sku">' + data.sku + '</span><span class="variant-name">' + data.name + '</span></div><span class="bmc-variant-suggestion-add">+</span>';
              div.addEventListener('click', () => {
                this._addVariant(data);
                this.searchInput.value = '';
                this.suggestions.innerHTML = '';
              });
              this.suggestions.appendChild(div);
            }

            _addVariant(variant) {
              if (this.selected.some(s => s.id === variant.id)) return;
              this.selected.push(variant);
              this._render();
            }

            _removeVariant(sku) {
              this.selected = this.selected.filter(s => s.id !== sku);
              this._render();
            }

            _render() {
              this.itemsContainer.innerHTML = '';
              this.selected.forEach(v => {
                const item = document.createElement('div');
                item.className = 'bmc-variant-item';
                item.innerHTML = '<div class="bmc-variant-item-info"><span class="bmc-variant-item-sku">' + v.sku + '</span><span class="bmc-variant-item-name">' + v.name + '</span></div><button type="button" class="bmc-variant-item-remove">&times;</button>';
                item.querySelector('.bmc-variant-item-remove').addEventListener('click', () => this._removeVariant(v.id));
                this.itemsContainer.appendChild(item);
              });

              this.hiddenInput.value = JSON.stringify(this.selected.map(s => s.id));
              this.field.classList.toggle('has-items', this.selected.length > 0);
            }

            async _loadDefaults() {
              const defaultValue = this.container.dataset.defaultValue;
              if (!defaultValue) return;

              const skus = defaultValue.split(',').map(s => s.trim()).filter(Boolean);
              if (skus.length === 0) return;

              if (this.loadingEl) this.loadingEl.style.display = 'flex';

              const results = await Promise.all(
                skus.map(sku =>
                  fetch('/apps/bmc/products/variant-by-sku/' + encodeURIComponent(sku))
                    .then(r => r.ok ? r.json() : null)
                    .catch(() => null)
                )
              );

              results.filter(Boolean).forEach(v => this.selected.push(v));
              this._render();

              if (this.loadingEl) this.loadingEl.style.display = 'none';
            }
          }
          // --- End VariantPicker class ---

          function getFormValues() {
              const formData = new FormData(form);
              const values = {};
              formData.forEach((value, key) => {
                  values[key] = value;
              });
  
  
              const checkboxes = form.querySelectorAll('input[type="checkbox"]');
                checkboxes.forEach(checkbox => {
                    if (!checkbox.checked) {
                        values[checkbox.name] = "false";
                    } else {
                        values[checkbox.name] = "True";
                    }
                });
  
              const radioButtons = form.querySelectorAll('input[type="radio"]');
              radioButtons.forEach(radio => {
                  if (radio.checked) {
                      values[radio.name] = radio.value;
                  } else if (!values[radio.name]) {
                      values[radio.name] = null;
                  }
              });

              form.querySelectorAll('.bmc-media-upload').forEach(function(container) {
                  var fileInput = container.querySelector('.bmc-media-upload-input');
                  var previewState = container.querySelector('.bmc-media-upload-preview');
                  var hasFile = fileInput.files && fileInput.files[0] && fileInput.files[0].size > 0;
                  var hasDefault = previewState && previewState.style.display !== 'none';
                  values[fileInput.name] = (hasFile || hasDefault) ? true : null;
              });

              return values;
          }
  
          function handleShowIf() {
              const values = getFormValues();
              const inputs = form.querySelectorAll('[data-show-if]');
              inputs.forEach(input => {
                  const condition = input.getAttribute('data-show-if');

                  try {
                      const shouldShow = eval(`let ${Object.keys(values).map(key => `${key.replaceAll("-","").replaceAll(" ","")} = values['${key}']`).join('; ')}; ${condition}`);
                      const gridColumn = input.closest('.bmc-grid > div');
                      if (gridColumn) {
                        gridColumn.style.display = shouldShow ? '' : 'none';
                      }
                      if (input.dataset.required){
                        if (!shouldShow)
                          input.setAttribute("disabled","disabled");
                        else
                          input.removeAttribute("disabled");
                      }
                  } catch (error) {
                      console.error("Error evaluating condition:", error);
                  }
              });

              // Check show_if on the form container itself
              const formContainer = form.closest('.bmc-form-container');
              if (formContainer && formContainer.dataset.showIf) {
                  try {
                      const shouldShow = eval(`let ${Object.keys(values).map(key => `${key.replaceAll("-","").replaceAll(" ","")} = values['${key}']`).join('; ')}; ${formContainer.dataset.showIf}`);
                      formContainer.style.display = shouldShow ? '' : 'none';
                  } catch (error) {
                      console.error("Error evaluating form container show_if:", error);
                  }
              }
          }
  
          function handleComputeValue() {
              const values = getFormValues();
              const inputs = form.querySelectorAll('[data-compute-value]');
              inputs.forEach(input => {
                  const script = input.getAttribute('data-compute-value');
                  let expression =`let ${Object.keys(values).map(key => `${key.replaceAll("-","").replaceAll(" ","")} = values['${key}']`).join('; ')}; ${script}`;
                  try {
                      eval(expression);
                      input.value = eval(script);
                  } catch (error) {
                      console.error("Error calculating value:", error,expression);
                  }
              });
              updateFloatingLabels();
          }
          
          function validateForm() {
              const requiredFields = form.querySelectorAll('[required],[pattern]');
              let valid = true;
              let firstInvalidField = null;

              requiredFields.forEach(input => {
                  // Skip hidden or disabled fields
                  const parentDiv = input.closest("div");
                  const isVisible = parentDiv && window.getComputedStyle(parentDiv).display !== 'none';
                  const isEnabled = !input.hasAttribute('disabled');

                  if (isVisible && isEnabled) {
                      if (!input.checkValidity()) {
                          parentDiv.classList.add('invalid');
                          valid = false;
                          if (!firstInvalidField) {
                              firstInvalidField = input;
                          }
                      } else {
                          parentDiv.classList.remove('invalid');
                      }
                  }
              });

              // Scroll to first invalid field and show browser validation message
              if (firstInvalidField) {
                  firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  firstInvalidField.focus();
                  // Trigger browser's native validation message
                  firstInvalidField.reportValidity();
              }

              return valid;
          }
         
                form.addEventListener('input', handleEvent);
                form.addEventListener('change', handleEvent);
                form.addEventListener('focus', handleEvent, true);
                form.addEventListener('blur', handleEvent, true);

                function handleEvent(e) {
                    handleShowIf();
                    handleComputeValue();

                    if (e.target.checkValidity())
                        e.target.closest("div").classList.remove('invalid');

                    updateFloatingLabels();
                }
      
              form.addEventListener('submit', (e) => {
                  e.preventDefault(); 
                  e.stopPropagation();

                  handleComputeValue();

                  if (validateForm()) {
                    const formValues = getFormValues();
                    const files = form.querySelectorAll('input[type="file"]');
                    files.forEach(file => {
                      //exclude file
                      delete formValues[file.name];
                    });
                    
                    let updateMetaObjectRequest ={};
                    
                    if (form.dataset.formtype!="Metaobject")
                        updateMetaObjectRequest = formValues;
                    else
                    {
                        const id = formValues.id;
                     
                        delete formValues.id;
                        delete formValues.utf8;
                        
                        updateMetaObjectRequest = {
                        id,
                        fields: Object.entries(formValues).map(([key, value]) => {
                                    return { key, value };
                                })
                        }
                    }
    
  
                    const formData = new FormData();
                     form.querySelectorAll('input[type="file"]').forEach(input => {
                      if (input.files.length > 0) {
                        formData.append(input.name, input.files[0]); 
                      }
                    });
  
                    formData.append("json", JSON.stringify(updateMetaObjectRequest));
                    let btn = form.querySelector(".btn");
                    
                    btn.disabled=true;
                    let originalButtonText= btn.innerText;
                    btn.textContent = btn.dataset.sendingtext;
                    
                    fetch(form.action, { method: 'POST', 
                      body:formData})
                      .then(function(response){ 
                          return response.text(); 
                      }) .then(function(data) {
                        
                        if (data=="ok" || form.dataset.formtype!="Metaobject")
                        {
                          let locale = form.querySelector('input[name="language"]').value;
                          
                          switch(locale){
                            case "en":
                              locale="";
                              break;
                            default:
                              locale="/"+ locale;
                              break;
                              
                          }
                          
                          let redirectUrl = locale + form.dataset.aftersubmit;

                          if (redirectUrl.includes('?')) {
                            let [path, queryString] = redirectUrl.split('?');
                            let params = new URLSearchParams(queryString);

                            params.forEach(function(value, key) {
                              let field = form.querySelector('[name="' + value + '"]');
                              if (field) {
                                params.set(key, field.value);
                              }
                            });

                            redirectUrl = path + '?' + params.toString();
                          }

                          window.location = redirectUrl;
                          return;
                          
                        } else alert("error");
  
                          btn.disabled=false;
                          btn.textContent = originalButtonText;
                        
                          //console.log('server response:', data); 
                      }) 
                      .catch(function(error) { 
                          console.error('Error:', error); 
                          btn.disabled=false;
                          btn.textContent = originalButtonText;
                      });
                     
                    
                  } else {
                     // console.log('Please fill the mandatory fields.');
                    return;
                  }
              });
  
            // Initialize cascading dropdowns
            const cascadeContainers = form.querySelectorAll('.bmc-cascade-container');
            cascadeContainers.forEach(container => {
              new CascadingDropdown(container, form);
            });

            // --- Variant Picker Init is in the per-section <script> tag ---

            // --- Media Upload Init ---
            form.querySelectorAll('.bmc-media-upload').forEach(container => {
              const fileInput = container.querySelector('.bmc-media-upload-input');
              const emptyState = container.querySelector('.bmc-media-upload-empty');
              const previewState = container.querySelector('.bmc-media-upload-preview');
              const imgEl = container.querySelector('.bmc-media-upload-img');
              const videoEl = container.querySelector('.bmc-media-upload-video');
              const playBtn = container.querySelector('.bmc-media-upload-play');
              const fullscreenBtn = container.querySelector('.bmc-media-upload-fullscreen');
              const changeBtn = container.querySelector('.bmc-media-upload-change');
              const mediaType = container.dataset.mediaType || 'image';

              fileInput.addEventListener('change', function() {
                if (!this.files || !this.files[0]) return;
                const file = this.files[0];
                const url = URL.createObjectURL(file);

                if (mediaType === 'video') {
                  videoEl.src = url;
                  videoEl.style.display = 'block';
                  imgEl.style.display = 'none';
                  playBtn.style.display = 'flex';
                } else {
                  imgEl.src = url;
                  imgEl.style.display = 'block';
                  videoEl.style.display = 'none';
                  playBtn.style.display = 'none';
                }

                emptyState.style.display = 'none';
                previewState.style.display = 'block';

                // Remove invalid state on file select
                container.closest('div').classList.remove('invalid');
              });

              if (changeBtn) {
                changeBtn.addEventListener('click', function(e) {
                  e.stopPropagation();
                  fileInput.click();
                });
              }

              if (playBtn) {
                playBtn.addEventListener('click', function() {
                  if (videoEl.paused) {
                    videoEl.play();
                    playBtn.style.display = 'none';
                  }
                });
                videoEl.addEventListener('click', function() {
                  videoEl.pause();
                  playBtn.style.display = 'flex';
                });
                videoEl.addEventListener('ended', function() {
                  playBtn.style.display = 'flex';
                });
              }

              fullscreenBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                form._openMediaModal(mediaType === 'video' ? videoEl : imgEl, mediaType);
              });

              if (!fileInput.disabled) {
                const acceptAttr = fileInput.getAttribute('accept') || '';
                const acceptList = acceptAttr.split(',').map(s => s.trim()).filter(Boolean);

                const matchesAccept = (file) => {
                  if (acceptList.length === 0) return true;
                  return acceptList.some(rule => {
                    if (rule.endsWith('/*')) return file.type.startsWith(rule.slice(0, -1));
                    if (rule.startsWith('.')) return file.name.toLowerCase().endsWith(rule.toLowerCase());
                    return file.type === rule;
                  });
                };

                ['dragenter', 'dragover'].forEach(ev => {
                  container.addEventListener(ev, (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    container.classList.add('is-dragging');
                  });
                });

                ['dragleave', 'dragend'].forEach(ev => {
                  container.addEventListener(ev, (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (ev === 'dragleave' && container.contains(e.relatedTarget)) return;
                    container.classList.remove('is-dragging');
                  });
                });

                container.addEventListener('drop', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  container.classList.remove('is-dragging');

                  const file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
                  if (!file) return;
                  if (!matchesAccept(file)) return;

                  const dt = new DataTransfer();
                  dt.items.add(file);
                  fileInput.files = dt.files;
                  fileInput.dispatchEvent(new Event('change', { bubbles: true }));
                });
              }
            });
            // --- End Media Upload Init ---

            // --- File Input Init ---
            form.querySelectorAll('.bmc-file-clear-btn').forEach(clearBtn => {
              clearBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                const field = this.closest('.bmc-field');
                const hiddenInput = field.querySelector('.bmc-file-hidden-input');
                const fileInfo = field.querySelector('.bmc-file-info');

                // Show the hidden file input as a standard input
                hiddenInput.style.display = '';
                hiddenInput.classList.add('input-full');
                // Remove the file info display
                fileInfo.remove();
                // Remove action buttons
                this.closest('.bmc-file-actions').remove();
              });
            });
            // --- End File Input Init ---

            // --- Media Modal Logic ---
            (function() {
              const sid = form.dataset.sectionId;
              const modal = document.getElementById(sid + '_bmcMediaModal');
              if (!modal) return;
              const overlay = modal.querySelector('.bmc-media-modal-overlay');
              const closeBtn = modal.querySelector('.bmc-media-modal-close');
              const modalImg = modal.querySelector('.bmc-media-modal-img');
              const modalImgWrap = modal.querySelector('.bmc-media-modal-img-wrap');
              const modalVideo = modal.querySelector('.bmc-media-modal-video');
              const controls = document.getElementById(sid + '_bmcMediaModalControls');
              const zoomLabel = modal.querySelector('.bmc-media-modal-zoom-level');

              let scale = 1;
              let panX = 0, panY = 0;
              let isDragging = false;
              let startX, startY;
              const MIN_SCALE = 0.5;
              const MAX_SCALE = 5;

              function updateTransform() {
                modalImg.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
                zoomLabel.textContent = Math.round(scale * 100) + '%';
                modalImg.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
              }

              function resetZoom() {
                scale = 1; panX = 0; panY = 0;
                updateTransform();
              }

              form._openMediaModal = function(sourceEl, type) {
                resetZoom();
                if (type === 'video') {
                  modalImg.style.display = 'none';
                  modalImgWrap.style.display = 'none';
                  modalVideo.style.display = 'block';
                  modalVideo.src = sourceEl.src || sourceEl.querySelector('source')?.src || '';
                  controls.style.display = 'none';
                } else {
                  modalVideo.style.display = 'none';
                  modalVideo.pause();
                  modalImg.style.display = 'block';
                  modalImgWrap.style.display = 'flex';
                  modalImg.src = sourceEl.src;
                  controls.style.display = 'flex';
                }
                modal.style.display = 'flex';
                document.body.style.overflow = 'hidden';
              };

              function closeModal() {
                modal.style.display = 'none';
                modalVideo.pause();
                modalVideo.src = '';
                document.body.style.overflow = '';
              }

              closeBtn.addEventListener('click', closeModal);
              overlay.addEventListener('click', closeModal);
              document.addEventListener('keydown', function(e) {
                if (e.key === 'Escape' && modal.style.display === 'flex') closeModal();
              });

              // Click to toggle zoom
              modalImg.addEventListener('click', function(e) {
                if (isDragging) return;
                if (scale >= 3) { resetZoom(); }
                else { scale = scale < 2 ? 2 : 3; panX = 0; panY = 0; updateTransform(); }
              });

              // Scroll wheel zoom
              modalImgWrap.addEventListener('wheel', function(e) {
                e.preventDefault();
                const delta = e.deltaY > 0 ? -0.25 : 0.25;
                scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, scale + delta));
                if (scale <= 1) { panX = 0; panY = 0; }
                updateTransform();
              }, { passive: false });

              // Drag/pan
              modalImg.addEventListener('mousedown', function(e) {
                if (scale <= 1) return;
                isDragging = true;
                startX = e.clientX - panX;
                startY = e.clientY - panY;
                modalImg.style.cursor = 'grabbing';
                e.preventDefault();
              });
              document.addEventListener('mousemove', function(e) {
                if (!isDragging) return;
                panX = e.clientX - startX;
                panY = e.clientY - startY;
                modalImg.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
              });
              document.addEventListener('mouseup', function() {
                if (isDragging) {
                  isDragging = false;
                  modalImg.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
                }
              });

              // Touch pinch zoom & pan
              let lastTouchDist = 0;
              let lastTouchX = 0, lastTouchY = 0;
              modalImgWrap.addEventListener('touchstart', function(e) {
                if (e.touches.length === 2) {
                  lastTouchDist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
                } else if (e.touches.length === 1 && scale > 1) {
                  lastTouchX = e.touches[0].clientX - panX;
                  lastTouchY = e.touches[0].clientY - panY;
                }
              }, { passive: true });
              modalImgWrap.addEventListener('touchmove', function(e) {
                if (e.touches.length === 2) {
                  e.preventDefault();
                  const dist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
                  const delta = (dist - lastTouchDist) * 0.01;
                  scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, scale + delta));
                  lastTouchDist = dist;
                  if (scale <= 1) { panX = 0; panY = 0; }
                  updateTransform();
                } else if (e.touches.length === 1 && scale > 1) {
                  e.preventDefault();
                  panX = e.touches[0].clientX - lastTouchX;
                  panY = e.touches[0].clientY - lastTouchY;
                  modalImg.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
                }
              }, { passive: false });

              // Zoom buttons
              controls.querySelectorAll('.bmc-media-modal-zoom-btn').forEach(function(btn) {
                btn.addEventListener('click', function() {
                  const action = btn.dataset.zoom;
                  if (action === 'in') scale = Math.min(MAX_SCALE, scale + 0.5);
                  else if (action === 'out') scale = Math.max(MIN_SCALE, scale - 0.5);
                  else { resetZoom(); return; }
                  if (scale <= 1) { panX = 0; panY = 0; }
                  updateTransform();
                });
              });
            })();
            // --- End Media Modal Logic ---

            function applyQueryStringDefaults() {
                 const params = new URLSearchParams(window.location.search);
                 params.forEach((value, key) => {
                     if (!key.startsWith('field_')) return;
                     const fieldName = key.substring(6);
                     const elements = form.querySelectorAll('[name="' + fieldName + '"]');
                     elements.forEach(element => {
                         if (element.type === 'checkbox') {
                             element.checked = (value === 'true');
                         } else {
                             element.value = value;
                         }
                     });
                 });
             }
             applyQueryStringDefaults();

             // Load company locations from API for {field}.company_location selects
             form.querySelectorAll('select[data-company-gid]').forEach(function(sel) {
               var gid = sel.getAttribute('data-company-gid');
               var selectDefault = sel.getAttribute('data-select-default') || '';
               var companyId = gid.split('/').pop();
               fetch('/apps/bmc/company/' + companyId + '/locations', { method: 'GET' })
                 .then(function(r) { return r.json(); })
                 .then(function(locations) {
                   locations.forEach(function(loc) {
                     var opt = document.createElement('option');
                     opt.value = loc.uuid;
                     opt.textContent = loc.name + ' - ' + loc.street + ', ' + loc.zip + ' ' + loc.city + ' Tel. ' + loc.phone;
                     if (loc.uuid === selectDefault || locations.length === 1) {
                       opt.selected = true;
                     }
                     sel.appendChild(opt);
                   });
                   // Auto-select if only one location
                   if (locations.length === 1) {
                     sel.value = locations[0].uuid;
                   }
                   handleShowIf();
                   handleComputeValue();
                 })
                 .catch(function(err) { console.error('Error loading company locations:', err); });
             });

             // Auto-select when a select has only one real option
             form.querySelectorAll('select.input-full').forEach(function(sel) {
               if (sel.hasAttribute('data-company-gid')) return; // handled by fetch above
               var realOptions = Array.from(sel.options).filter(function(o) { return o.value !== ''; });
               if (realOptions.length === 1 && sel.value === '') {
                 sel.value = realOptions[0].value;
               }
             });
             handleShowIf();
             handleComputeValue();
             updateFloatingLabels();

             // Start monitoring field value changes
             monitorFieldChanges();

      }); // end forEach form

  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-info-mo"] && !Shopify.designMode) return;
  try {
    
  const features = document.querySelectorAll('.feature-info__item');
  for (let i = 0; i < features.length; i++) {
    features[i].addEventListener("click", function() {
      let isExpanded = features[i].getAttribute("aria-expanded");
      if (isExpanded == "true") {
        isExpanded = "false"
      } else {
        isExpanded = "true"
      }
      features[i].setAttribute("aria-expanded", isExpanded);
    });
  } 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-info"] && !Shopify.designMode) return;
  try {
    
  const features = document.querySelectorAll('.feature-info__item');
  for (let i = 0; i < features.length; i++) {
    features[i].addEventListener("click", function() {
      let isExpanded = features[i].getAttribute("aria-expanded");
      if (isExpanded == "true") {
        isExpanded = "false"
      } else {
        isExpanded = "true"
      }
      features[i].setAttribute("aria-expanded", isExpanded);
    });
  } 

  } catch(e) { console.error(e); }
})();
})();
